export const BREAKPOINTS = {
  PHONE: 600,
  TABLET: 842,
  WIDE_TABLET: 1350,
  LAPTOP: 1728,
} as const;
